import React from 'react';
import { LocalizationContext } from '../../foundation/ShopifyProvider/ShopifyProvider.client.js';
export default function LocalizationClientProvider({ localization, children, }) {
    return (React.createElement(LocalizationContext.Provider, { value: localization }, children));
}
